import {createForm, fieldStyles} from "core/form/createForm";
import {FormProps, lovLabel, lovValue} from "core/form/formUtils";
import {observer} from "mobx-react";
import React from "react";
import mdEntityService from "core/metamodel/mdEntityService";
import {action, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import StyledSelect from "core/components/fields/styledSelect";
import {ExtendedPreferences, UserProfileDto} from "core/security/securityDomain";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import MdField, {VALUESOURCETYPE} from "core/metamodel/mdField";


/* ************************************************************************************************
 * ***********   Invoice  *************************************************************
 * ********************************************************************************************** */


const InvoicePreferenceFormCC = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<ExtendedPreferences>) => {
  let invoicewarningEntity = entities.get("INVOICEWARNING");
  return (
    <ClosedFormBlock {...{dataObject, entity, entities, fields}} singleColumn>
      <ClosedFormField label={fields.enabledInvoiceWarnings.textLabel}>
        {dataObject.enabledInvoiceWarnings.map(eiw => <div key={lovValue(eiw)}>{lovLabel(invoicewarningEntity.getLovItem(lovValue(eiw)))}</div>)}
      </ClosedFormField>
    </ClosedFormBlock>
  );
};


@createForm({
  formName: 'InvoicePreferenceForm',
  fields: [{
    name: 'enabledInvoiceWarnings',
    mdField: new MdField({label: 'Enabled Invoice issue warnings', valueSource: 'INVOICEWARNING', valueSourceType: VALUESOURCETYPE.LOCAL}),
    omitNullOption: true
  }],
  onCommit(dataObject) {
    dataObject.arguments = [lovValue(dataObject.importType), dataObject.directory, dataObject.filenamePattern];
  }
}, InvoicePreferenceFormCC)
@observer
export class InvoicePreferenceForm extends React.Component<FormProps<ExtendedPreferences, UserProfileDto>, undefined> {

  componentDidMount() {
    console.debug('InvoicePreferenceForm componentDidMount');
    let {dataObject, form} = this.props;

    mdEntityService.fetchEntities([{
      entity: 'INVOICEWARNING',
      lov: true
    }]).then(action("action-cb", (entityMap: ObservableMap<MdEntity>) => {
      form.initForm(entityMap.get("JobInfo"), entityMap, dataObject, dataObject, null);
      form.updateAllFieldsPropValue(dataObject);
    }));
  }

  render() {
    const {dataObject, rootObject, index, entities, entity, formName, disabled} = this.props;
    let fields = dataObject.getFormFields(formName);
    let {enabledInvoiceWarnings} = fields;

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <StyledSelect {...fieldStyles.small.styledSelect}  {...enabledInvoiceWarnings.props}  multi fullWidth clearable={false} floatingLabelStyle={{top: 15}}/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/security/component/userProfileForms.tsx